import { RECORD_MIME_TYPE } from '../constants';

export const isRecordAllowed = () => MediaRecorder.isTypeSupported(RECORD_MIME_TYPE);
